import { render } from "./ModuleUnit5.vue?vue&type=template&id=3b80e530"
import script from "./ModuleUnit5.vue?vue&type=script&lang=js"
export * from "./ModuleUnit5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__